export const search = {
  Songs: 'Músicas',
  Playlists: 'Playlists',
  'Top Result': 'Resultado Principal',
  'No results': 'Sem resultados',
  'No results where found for': 'Nenhum resultado encontrado para',
};
